/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onUpdateDataExportStatus = /* GraphQL */ `subscription OnUpdateDataExportStatus($userId: String!) {
  onUpdateDataExportStatus(userId: $userId) {
    userId
    status
    exportMessage
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDataExportStatusSubscriptionVariables,
  APITypes.OnUpdateDataExportStatusSubscription
>;
export const onUpdateBulkImportStatus = /* GraphQL */ `subscription OnUpdateBulkImportStatus($userId: String!) {
  onUpdateBulkImportStatus(userId: $userId) {
    userId
    status
    fileURL
    importMessage
    errorCode
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBulkImportStatusSubscriptionVariables,
  APITypes.OnUpdateBulkImportStatusSubscription
>;
export const onUpdateSurveyCreationStatus = /* GraphQL */ `subscription OnUpdateSurveyCreationStatus($userId: String!) {
  onUpdateSurveyCreationStatus(userId: $userId) {
    userId
    jobId
    status
    surveyId
    message
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateSurveyCreationStatusSubscriptionVariables,
  APITypes.OnUpdateSurveyCreationStatusSubscription
>;
export const onJobProgress = /* GraphQL */ `subscription OnJobProgress($userId: String!) {
  onJobProgress(userId: $userId) {
    userId
    jobId
    jobType
    status
    percent
    phase
    message
    error {
      message
      details
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnJobProgressSubscriptionVariables,
  APITypes.OnJobProgressSubscription
>;
